/* eslint-disable */
import { userInfo, loginName, logout, password } from "../../../api/auth/login";
import * as types from "../../mutation-types";
import { constantRouterMap } from "../../../router";
import {
    getToken,
    setToken,
    removeToken,
    getAdminId,
    setAdminId,
    removeAdminId
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
// console.log(constantRouterMap)
const state = {
    adminId: getAdminId(), // id
    userName: "", // 昵称
    avatar: "", // 头像
    token: getToken(), // 登录token
    authRules: [], // 权限列表
    routers: constantRouterMap, // 路由列表
    Height: ""
};

// getters
const getters = {
    adminId: state => state.adminId,
    userName: state => state.userName,
    avatar: state => state.avatar,
    token: state => state.token,
    authRules: state => state.authRules,
    routers: state => state.routers
};

// mutations
const mutations = {
    [types.RECEIVE_ADMIN_ID](state, adminId) {
        state.adminId = adminId;
        if (adminId === "") {
            removeAdminId();
        } else {
            setAdminId(adminId);
        }
    },
    [types.RECEIVE_ADMIN_TOKEN](state, token) {
        state.token = token;
        if (token === "") {
            removeToken();
        } else {
            setToken(token);
        }
    },
    [types.RECEIVE_ADMIN_NAME](state, userName) {
        state.userName = userName;
    },
    [types.RECEIVE_ADMIN_AVATAR](state, avatar) {
        state.avatar = avatar;
    },
    [types.RECEIVE_ADMIN_AUTH_RULES](state, authRules) {
        state.authRules = authRules;
    },
    [types.RECEIVE_ROUTERS](state, routers) {
        // const tempRm = constantRouterMap.concat(routers);
        // state.routers = JSON.parse(JSON.stringify(tempRm));
    },
    Height(state, data) {
        state.Height = data
    },
    MENU_LIST_SHOW(state, data) {
        state.routers = JSON.parse(JSON.stringify(data));
    }
};

// actions
const actions = {
    // 用户名登录
    loginName({ commit }, userInfo) {
        const userName = userInfo.userName ? userInfo.userName.trim() : "";
        const pwd = userInfo.pwd ? userInfo.pwd : "";
        commit(types.RECEIVE_ADMIN_NAME, '');
        commit(types.RECEIVE_ADMIN_AVATAR, '');
        commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
        return new Promise((resolve, reject) => {
            loginName(userName, pwd)
                .then(response => {
                    if (response.data.code) {
                        Message({
                            message: response.data.message,
                            type: "error",
                            duration: 5 * 1000
                        });
                    } else {
                        let data = response.data.data;
                        commit(types.RECEIVE_ADMIN_ID, data.id);
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
                    }
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    userInfo({ commit }) {
        return new Promise((resolve, reject) => {
            userInfo(getAdminId(), getToken())
                .then(response => {
                    if (response.data.code === 2) {
                        reject("登录失效");
                    }
                    const data = response.data.data || {};
                    commit(types.RECEIVE_ADMIN_NAME, data.username);
                    commit(types.RECEIVE_ADMIN_AVATAR, data.avatar);
                    commit(types.RECEIVE_ADMIN_AUTH_RULES, data.authRules);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 登出
    loginOut({ commit }) {
        return new Promise((resolve, reject) => {
            logout(getAdminId(), getToken())
                .then(() => {
                    commit(types.RECEIVE_ADMIN_ID, "");
                    commit(types.RECEIVE_ADMIN_TOKEN, "");
                    commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 修改密码
    EditPassword({ commit }, data) {
        console.log(data)
        return new Promise((resolve, reject) => {
            password(data)
                .then(res => {
                    // console.log(res)
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 前端 登出
    fedLogout({ commit }) {
        return new Promise(resolve => {
            commit(types.RECEIVE_ADMIN_ID, "");
            commit(types.RECEIVE_ADMIN_TOKEN, "");
            commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
            resolve();
        });
    },
    /**
     * 过滤路由列表
     * @param commit
     * @param data
     * @returns {Promise}
     */
    filterRouter({ commit }, data) {
        const { accessedRouters } = data;
        if (accessedRouters && accessedRouters.length > 0) {
            commit(types.RECEIVE_ROUTERS, accessedRouters);
        }
    },
    AccountSetHeight({ commit }, data) {
        commit('Height', data);
    },
    MenulistShow ({ commit }, data) {
        axios.post(http + '/auth/menu/menuList', data).then(res => {
            commit('MENU_LIST_SHOW', res.data.data)
        })
    }
};

const loginModule = {
    state,
    getters,
    actions,
    mutations
}
export default loginModule
